import type { CreateDataObjectDetailsModelReturn } from "@certa/queries/types/dataObjectsAPIs.types";
import type {
  Badge,
  Field,
  FieldExtraDataFromAPI,
  StepDetails
} from "@certa/types";

export type TFieldProps = {
  field: Field;
  currentStepFields: FieldExtraDataFromAPI;
  fieldInProgressData: any;
  error?: Record<string, string>;
  onFieldChange: (
    value: any,
    props: any,
    calculated: boolean | string,
    extraJSON?: Record<string, any>
  ) => void;
  clearResponse: (args: any) => void;
  source: string;
  isReadOnlyWorkflow: boolean;
  completed: boolean;
  is_locked: boolean;
  refetchCurrentStepFields: () => void;
  handleStepUpdateSideEffects: () => void;
  workflowId: number;
  workflowKindId?: number;
  validateAnswer: (field: Field, value: any) => boolean;
  saveResponse: (arg: any) => void;
  hideCommentButton?: boolean;
  stepData: StepDetails;
  decryptURL?: string;
  shouldDecryptURL?: boolean;
  setMultiFileUploadInProgress: () => void;
  resetMultiFileUploadInProgress: () => void;
  dynamicUserPerms?: Record<string, any>;
  // Actual type for permission is
  // permission: Record<
  //   number,
  //   {
  //     codename: string;
  //     name: string;
  //   }
  // >;
  permission: string[];
  isWorkflowBeingMigrated?: boolean;
  isNonEditable?: boolean;
  // Only used for DataObjectMappingField
  workflowDataObjects?: {
    objectInstances: CreateDataObjectDetailsModelReturn["objectInstances"];
    objectTypes: CreateDataObjectDetailsModelReturn["objectTypes"];
  };
  badges?: Badge[];
  clearFieldError: (fieldId: number) => void;
};

export enum FieldStatus {
  SUCCESS = "Success",
  ERROR = "Error",
  LOADING = "Loading"
}

export type RagFieldStyle = {
  boxShadow?: string;
  border?: string;
  borderRadius?: string;
  backgroundColor?: string;
  focusedBorder?: string;
  checkMarkColor?: string;
};

export type TextInputContainerStyle = RagFieldStyle;

export type NumberInputContainerStyle = RagFieldStyle;

export type RagIndicator = "R" | "A" | "G";

export type RagStatusIndicator = {
  indicator: RagIndicator;
  helpText?: string;
};

export const RAGStatusText: { [key: string]: string } = {
  R: "HIGH",
  A: "MED",
  G: "LOW"
};
